export default "/images/bold.svg?b04d18b95c3a94680dc5e2b8ec900be4";